import report from '@/model/report'

const install = function (Vue) {
  // 使用方式，及传值 binding参数  v-operating:event.custom='按钮名称'
  Vue.directive('operating', {
    inserted: (el, binding) => {
      // 绑定click事件 此处来进行记录工作
      // binding {value-btnName,arg->evnet,modifiers:{}}
      el.dataset.value = binding.value
      el.addEventListener(binding.arg || 'click', () => {
        if (!el.dataset.value) { // 如果没有value的话，不提交
          return
        }
        report.traceEvent(binding.arg || 'click', el.dataset.value)
      })
    },
    componentUpdated: (el, binding) => {
      el.dataset.value = binding.value
    }
  })
}

export default install
